<template>
<div class="content" v-loading="loading">
  <div class="header">
    <el-button @click="getCustomerExcel(1)">预览</el-button>
    <el-button @click="getCustomerExcel(0)">导出</el-button>
    <el-button @click="back">返回</el-button>
  </div>
  <div class="body">
    <el-descriptions :column="1" direction="vertical" border>
      <el-descriptions-item size="mini">
        <template slot="label">
          <span style="font-weight: bold;color: black;font-size: 18px;">装修信息明细表</span>
        </template>
        <el-descriptions size="mini" :column="2" border :label-style="{width:'100px'}" :contentStyle="{maxWidth:'300px',wordBreak:'break-all'}">
          <el-descriptions-item label="房产信息">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.house_name"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.ApplyDate_start_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择开始时间">
            </el-date-picker>
            至
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.ApplyDate_end_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择结束时间">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="装修时间">
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.BeginDate_start_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择开始时间">
            </el-date-picker>
            至
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.BeginDate_end_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择结束时间">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="装修状态">
            <el-checkbox-group size="mini" v-model="where.ProcessState">
              <el-checkbox v-for="(item,index) in status_list" :key="index" :label="item.value">{{ item.name }}</el-checkbox>
<!--              <el-checkbox :label="1">已收</el-checkbox>-->
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="装修单位">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.CompanyID"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="装修负责人">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.CompanyMaster"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="负责人电话">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.CompanyMasterPhone"
              clearable>
            </el-input>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <ViewFile ref="ViewFile" />
</div>
</template>

<script>
import AppConfig from "../../../../config/AppConfig";
import ViewFile from "../../Common/ViewFile";

export default {
  name: "FitmentList",
  components: {ViewFile},
  inject:['ReportCustomer'],
  data(){
    return{
      where:{
        house_name:"",
        ApplyDate_start_date:"",
        ApplyDate_end_date:"",
        BeginDate_start_date:"",
        BeginDate_end_date:"",
        ProcessState:[0,1,2,3,4,5,6],
        CompanyID:"",
        CompanyMaster:"",
        CompanyMasterPhone:"",
        project_id:0
      },
      loading:false,
      status_list:[
        {name:"未审批",value:0},
        {name:"审批中",value:1},
        {name:"已审批",value:2},
        {name:"已缴费",value:3},
        {name:"已入场",value:4},
        {name:"已取消",value:5},
        {name:"已完成",value:6},
      ],
    }
  },
  mounted() {
    this.where.house_name=this.ReportCustomer.house_name;
    this.where.project_id=this.ReportCustomer.project_id;
  },
  methods:{
    back(){
      this.ReportCustomer.customerMenuIndex="CustomerMain";
    },
    getCustomerExcel(ready_type=1){
      const that=this;
      if(!that.where.house_name){
        that.$message.error('请选择项目/房产！')
        return false;
      }
      that.loading=true;
      let where=ERP.reJson(that.where)
      where.ProcessState=where.ProcessState.join(',');
      ERP.postRequest({
        url: "admin/HouseFurnish/getListExcel",
        data: where
      }, res => {
        if (res.code) {
          if(ready_type===1){
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:"预览文件",
              src:AppConfig.erp_server+res.data,
              download(){
                // TODO 下载文件逻辑
                window.open(AppConfig.erp_server+res.data)
              }
            })
          }else {
            window.open(AppConfig.erp_server+res.data);
          }
        }
        that.loading = false;
      })
    }
  },
  watch:{
    "ReportCustomer.house_name":function (n,o) {
      this.where.house_name=n;
      this.where.project_id=this.ReportCustomer.project_id;
    }
  }

}
</script>

<style lang="scss" scoped>
.content{
  .header{
    display: flex;
    flex-direction: row;
  }
  .body{
    margin-top: 10px;

    .c-input{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/FitmentList.vue